import type { FaireProductEntity } from "../../entity_types/product";

export const p_md46uzruhg: FaireProductEntity = {
  token: "p_md46uzruhg",
  type: "product",
  name: "Crystal Squirrels",
  brandToken: "b_5wk9sqf7b2",
  brandName: "Chaotic Crystal Chick Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/1f7440bda4ea0ddbe4785c058756a00417d256b96c6124fa67e6bbc31fea9dfd.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d6d723e082c7450f11013f4da3d45821370827b1042b055718e37b99a77743db.jpeg",
  ],
  priceDollars: 12.47,
  description:
    "Choose the material of your fun crystal carving. Many of our carvings have multiple materials available and while we will try to update photos when new materials come in, there may be a gap in some updates. Please note most photos are the exact piece you will get, however sometimes we have duplicate shapes in the same material so there may be some variant in what you receive as these are natural crystals and minerals and no two pieces are exactly alike.\n",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:49:52.046Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
